import { get, post } from './../Config/config';

export const Notes = {
    getNotes: (data) => get(`/lead/notes`, { params: data }),
    add: (data) => post('/lead/save-note', data),
    DeleteNote: (data) => post('/lead/delete-note', data),
    UpdateNotes: (data) => post('/lead/update-note', data),
} 